import * as React from "react";

export function CloseX(props) {
  return (
    <svg
      width={15}
      height={15}
      viewBox="0 0 21 21"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11 .5C16.798.5 21.5 5.202 21.5 11S16.798 21.5 11 21.5.5 16.798.5 11 5.202.5 11 .5zm0 1.781A8.72 8.72 0 002.281 11 8.72 8.72 0 0011 19.719 8.72 8.72 0 0019.719 11 8.72 8.72 0 0011 2.281zm3 4.66l.002.002 1.055 1.055.002.002V8l-.002.002L12.061 11l2.996 2.997.002.001V14l-.002.002-1.055 1.055-.002.002H14l-.002-.002L11 12.061l-2.997 2.996a.006.006 0 01-.002.002H8l-.002-.002-1.055-1.055A.006.006 0 016.94 14V14l.002-.002L9.939 11 6.943 8.003l-.002-.001V8l.002-.002 1.055-1.055L8 6.94H8l.002.002L11 9.939l2.997-2.996.002-.002H14z"
        fill="currentColor"
      />
    </svg>
  );
}